module.exports = __webpack_public_path__ + "media/images/appTitle-a8f399a02f0a39a439e805e2d2464735.png";